import Link from "next/link";
import { useRouter } from "next/router";
import clsx from "clsx";
import { TbBrandInstagram, TbBuilding, TbDeviceMobile, TbInfinity, TbMoneybag, TbPaint, TbSearch, TbSpeakerphone } from "react-icons/tb";
import { SiBigcommerce } from "react-icons/si";
import { FaGoogle } from "react-icons/fa6";
import { BiParty } from "react-icons/bi";

const categoryIcon = (category) => {
  if (category === "Mobile Web Design") {
    return <TbDeviceMobile />;
  }
  if (category === "Google") {
    return <FaGoogle />;
  }
  if (category === "Design") {
    return <TbPaint />;
  }
  if (category === "Social Media") {
    return <TbBrandInstagram />;
  }
  if (category === "Small Business") {
    return <TbBuilding />;
  }
  if (category === "SEO") {
    return <TbSearch />;
  }
  if (category === "eCommerce") {
    return <TbMoneybag />;
  }
  if (category === "Marketing") {
    return <TbSpeakerphone />;
  }
  if (category === "BigCommerce") {
    return <SiBigcommerce />;
  }
  if (category === "Events") {
    return <BiParty />;
  }
};

const Sidebar = ({ categories, categoriesWithPostCounts }) => {
  const router = useRouter();
  return (
    <aside className="mt-5 lg:mt-0 w-full max-w-xl lg:max-w-[300px] mx-auto lg:w-4/5 p-5 rounded-3xl border self-start align-top h-auto flex flex-col sticky top-0">
      <h3 className="text-sm font-medium mona mb-2.5 leading-none">Categories</h3>
      <div className="flex flex-col gap-1">
        <Link
          className={clsx(
            "flex items-center gap-2 hover:bg-neutral-100 px-2 py-2 text-sm rounded-md",
            router.pathname === "/learn" && "bg-neutral-100"
          )}
          href="/learn"
        >
          <TbInfinity />
          All Categories
        </Link>
        {categories
          .sort(
            (a, b) =>
              categoriesWithPostCounts.find((cat) => cat._id === b._id).postCount -
              categoriesWithPostCounts.find((cat) => cat._id === a._id).postCount
          )
          .map((category) => {
            return (
              <Link
                key={category._id}
                className={clsx(
                  "flex items-center gap-2 hover:bg-gray-100 px-2 py-2 text-sm rounded-md relative",
                  router.pathname === `/learn/category/${category.slug.current}` && "bg-neutral-100"
                )}
                href={`/learn/category/${category.slug.current}`}
              >
                {categoryIcon(category.title)}
                {category.title}

                <span className="absolute right-2 text-neutral-500 rounded-full leading-none h-6 w-6 shrink-0 flex items-center justify-center text-sm">
                  {categoriesWithPostCounts.find((cat) => cat._id === category._id).postCount}
                </span>
              </Link>
            );
          })}
      </div>
    </aside>
  );
};

export default Sidebar;
